import React, { useState } from "react";
//import ReactDOM from "react-dom";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";

//npm install @material-ui/core
const steps = [
  "Proyecto de Investigación",
  "Requerimientos de microdatos",
  "Jefe, supervisores y otros participantes",
];

export default function Stepper1() {
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    if (activeStep < 2) setActiveStep((currenStep) => currenStep + 1); //aumentar el 3 dependiendo del no. de elemntos
  };

  const handleBack = () => {
    setActiveStep((currenStep) => currenStep - 1);
  };

  return (
    <div>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => {
          return (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep !== steps.length - 1 && (
        <React.Fragment>
          <Button onClick={handleNext}>
            {activeStep === steps.length - 1 ? "Terminar" : "Siguiente"}
          </Button>
        </React.Fragment>
      )}
      <Button onClick={handleBack} disabled={activeStep === 0}>
        Atras
      </Button>
      <h3>Paso {activeStep + 1}</h3>
    </div>
  );
}
